var _rect, _image, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeficientGrades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 175 179",
    enableBackground: "new 0 0 175 179",
    xmlSpace: "preserve",
    width: 175,
    height: 179,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "svgEditorBackground",
    x: 0,
    y: 0,
    width: 175,
    height: 179,
    style: {
      fill: "none",
      stroke: "none"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.190021,
    fill: "#FFFFFF",
    stroke: "#D1D1D1",
    strokeMiterlimit: 10,
    width: 175,
    height: 179,
    y: 1.52017
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 152,
    height: 106,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABqCAYAAABAmJgzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ bWFnZVJlYWR5ccllPAAAA3NpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdp bj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6 eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1 NDkxMSwgMjAxMy8xMC8yOS0xMTo0NzoxNiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJo dHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlw dGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEu MC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVz b3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1N Ok9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowYmU1OWNhZC0wNWE0LTQ0OWUtOTE5NS00OTdl M2JhMzI2NGQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Q0Y3MTVEQjU3ODNGMTFFNDg2RDND MDYwNjQ1RjI2NzQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Q0Y3MTVEQjQ3ODNGMTFFNDg2 RDNDMDYwNjQ1RjI2NzQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNp bnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NGY1 N2MxYTktYTE1Zi00NTUyLWE5ZjQtOWNiYmQ2MGNkZjYwIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAu ZGlkOjBiZTU5Y2FkLTA1YTQtNDQ5ZS05MTk1LTQ5N2UzYmEzMjY0ZCIvPiA8L3JkZjpEZXNjcmlw dGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pl4W3BQAAAFX SURBVHja7NnRCQIxEEVRI9aUtgWxv+wWkN9n5HEO2IBcmNnMmHOuB4Q8/QUIDIGBwBAYAgOBITAE BgLjj73u3/A3kDLWcorEiERgIDB+veS/P1//AtGvSFs+RiQCA4EhMMqWfKciYpyKMCIRGAiMA0u+ UxHpr0hbPkYkAgOBITDKlnynImKcijAiERjsdzAv+aSXfEsYRiQCA4EhMMqWfC/5xHjJx4hEYCAw Diz5TkWkvyJt+RiRCAwEhsAoW/KdiohxKsKIRGCw38G85JNe8i1hGJEIDASGwChb8r3kE+MlHyMS gYHAOLDkOxWR/oq05WNEIjAQGAKjbMl3KiLGqQgjEoHBfgfzkk96ybeEYUQiMBAYAqNsyfeST4yX fIxIBAYC48CS71RE+ivSlo8RicBAYAiMsiXfqYgYpyKMSAQG+x3MSz7pJd8ShhGJwEBgCIwilwAD AInCOUTmrIM1AAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 11.4998 51.0618)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontFamily: "Arial"
    },
    x: 21.6576,
    y: 7.60085,
    id: "e1_texte"
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      nullfill: "black",
      fontFamily: "Trebuchet MS",
      fontWeight: "bold",
      fontSize: "13.3015px",
      fillOpacity: 0.8
    },
    x: 41.9899,
    y: 21.6624,
    id: "e2_texte"
  }, "Deficient Grades"), /*#__PURE__*/React.createElement("rect", {
    x: 70.113,
    y: 49.9756,
    style: {
      fill: "white",
      stroke: "none",
      strokeWidth: 1
    },
    id: "e3_rectangle",
    width: 98.0509,
    height: 107.932
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.4432,
    y: 68.4076,
    style: {
      fill: "gold",
      stroke: "none",
      strokeWidth: 1
    },
    id: "e4_rectangle",
    width: 19.7622,
    height: 4.37049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.6141,
    y: 79.2388,
    style: {
      fill: "gold",
      stroke: "none",
      strokeWidth: 1
    },
    id: "e2_rectangle",
    width: 11.2112,
    height: 4.18047
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.405,
    y: 88.1698,
    style: {
      fill: "gold",
      stroke: "none",
      strokeWidth: 1
    },
    id: "e1_rectangle",
    width: 3.23035,
    height: 4.37049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.3838,
    y: 99.9511,
    style: {
      fill: "gold",
      stroke: "none",
      strokeWidth: 1
    },
    id: "e5_rectangle",
    width: 14.4416,
    height: 4.94055
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.265,
    y: 121.613,
    style: {
      fill: "gold",
      stroke: "none",
      strokeWidth: 1
    },
    id: "e6_rectangle",
    width: 5.89065,
    height: 4.75053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.9634,
    y: 131.304,
    style: {
      fill: "gold",
      stroke: "none",
      strokeWidth: 1
    },
    id: "e7_rectangle",
    width: 19.7622,
    height: 4.37049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.6142,
    y: 151.826,
    style: {
      fill: "gold",
      stroke: "none",
      strokeWidth: 1
    },
    id: "e8_rectangle",
    width: 11.9713,
    height: 4.75053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.3954,
    y: 68.4076,
    style: {
      fill: "darkblue",
      stroke: "none",
      strokeWidth: 1
    },
    id: "e9_rectangle",
    width: 22.6125,
    height: 4.37049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.3954,
    y: 79.2388,
    style: {
      fill: "darkblue",
      stroke: "none",
      strokeWidth: 1
    },
    id: "e10_rectangle",
    width: 35.534,
    height: 4.18047
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.2054,
    y: 88.3598,
    style: {
      fill: "darkblue",
      stroke: "none",
      strokeWidth: 1
    },
    id: "e11_rectangle",
    width: 41.8047,
    height: 4.18047
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.0154,
    y: 100.141,
    style: {
      fill: "darkblue",
      stroke: "none",
      strokeWidth: 1
    },
    id: "e12_rectangle",
    width: 29.4533,
    height: 4.37049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.5356,
    y: 121.993,
    style: {
      fill: "darkblue",
      stroke: "none",
      strokeWidth: 1
    },
    id: "e13_rectangle",
    width: 36.6741,
    height: 4.37049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.1556,
    y: 131.494,
    style: {
      fill: "darkblue",
      stroke: "none",
      strokeWidth: 1
    },
    id: "e14_rectangle",
    width: 29.4533,
    height: 4.37049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.9656,
    y: 152.206,
    style: {
      fill: "darkblue",
      stroke: "none",
      strokeWidth: 1
    },
    id: "e15_rectangle",
    width: 34.7739,
    height: 4.37049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.2054,
    y: 110.402,
    style: {
      fill: "darkblue",
      stroke: "none",
      strokeWidth: 1
    },
    id: "e16_rectangle",
    width: 46.3652,
    height: 4.18047
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.1555,
    y: 142.136,
    style: {
      fill: "darkblue",
      stroke: "none",
      strokeWidth: 1
    },
    id: "e17_rectangle",
    width: 46.3652,
    height: 4.18047
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.87632,
    y: 48.2654,
    style: {
      fill: "white",
      stroke: "none",
      strokeWidth: 1
    },
    id: "e18_rectangle",
    width: 61.9469,
    height: 16.9119
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeficientGrades);
export default __webpack_public_path__ + "static/media/deficientGrades.bd506053ebc5d763721341b0a27d41a0.svg";
export { ForwardRef as ReactComponent };